import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class EventsApi {
    static getAllEventsData () {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/`, {
            ...UserApi.GetDefualtMethod
        });
    }

    static getEventData (eventID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}`, {
            ...UserApi.GetDefualtMethod
        });
    }

    static updateEvent (eventID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/events.js